import { render, staticRenderFns } from "./courseStart.vue?vue&type=template&id=54d33f11&scoped=true"
import script from "./courseStart.vue?vue&type=script&lang=js"
export * from "./courseStart.vue?vue&type=script&lang=js"
import style0 from "./courseStart.vue?vue&type=style&index=0&id=54d33f11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d33f11",
  null
  
)

export default component.exports